import React, { useEffect, useState } from "react";
import { exitImpersonation, ImpersonationInfo } from "../auth/session";

interface Props {
  info: ImpersonationInfo;
}

const minutesLeft = (expiresAt: string) =>
  Math.max(0, Math.ceil((new Date(expiresAt).getTime() - Date.now()) / 60000));

/**
 * Fixed bottom bar + red viewport frame shown for the whole impersonation session.
 * Writes are rejected server-side; this is only the visual indicator + exit.
 */
export const ImpersonationBanner: React.FC<Props> = ({ info }) => {
  const [left, setLeft] = useState(() => minutesLeft(info.expiresAt));

  useEffect(() => {
    const tick = () => {
      const m = minutesLeft(info.expiresAt);
      setLeft(m);
      if (new Date(info.expiresAt).getTime() <= Date.now()) {
        exitImpersonation();
      }
    };
    const id = window.setInterval(tick, 15000);
    return () => window.clearInterval(id);
  }, [info.expiresAt]);

  return (
    <>
      {/* Spacer so the fixed bar never hides the end of the page. */}
      <div style={{ height: "44px" }} />
      {/* Red frame around the whole viewport: impossible to miss. */}
      <div
        aria-hidden="true"
        style={{
          position: "fixed",
          inset: 0,
          border: "3px solid #dc2626",
          pointerEvents: "none",
          zIndex: 10000,
        }}
      />
      <div
        role="alert"
        data-testid="impersonation-banner"
        style={{
          position: "fixed",
          bottom: 0,
          left: 0,
          right: 0,
          zIndex: 10001,
          backgroundColor: "#dc2626",
          color: "white",
          padding: "8px 16px",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          gap: "16px",
          fontWeight: 600,
          fontSize: "14px",
          boxShadow: "0 2px 8px rgba(0,0,0,0.4)",
        }}
      >
        <span>
          Viewing as @{info.username} — read-only — {left} min left
        </span>
        <button
          onClick={() => exitImpersonation()}
          style={{
            backgroundColor: "white",
            color: "#dc2626",
            border: "none",
            borderRadius: "6px",
            padding: "4px 14px",
            fontWeight: 700,
            cursor: "pointer",
          }}
        >
          Exit
        </button>
      </div>
    </>
  );
};

export default ImpersonationBanner;
